import { Link, useForm } from '@inertiajs/react'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'
import { Notice } from '@/components/ui/Notice'

export default function ForgotPassword() {
  const form = useForm({ email: '' })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.transform((data) => ({ user: data }))
    form.post('/users/password')
  }

  return (
    <AuthLayout>
      <div className="w-full max-w-sm">

        <div className="text-center mb-8">
          <p className="font-mono text-xs uppercase tracking-widest text-accent mb-4">
            Account recovery
          </p>
          <h1 className="font-serif text-3xl font-medium text-heading mb-2">
            Reset your password
          </h1>
          <p className="text-sm text-muted font-light">
            We'll send a reset link to your email address.
          </p>
        </div>

        {form.wasSuccessful ? (
          <Notice title="Check your inbox">
            If an account exists for <span className="text-body">{form.data.email}</span>,
            a reset link is on its way.
          </Notice>
        ) : (
          <form onSubmit={handleSubmit} noValidate className="flex flex-col gap-5">
            <Input
              id="email"
              label="Email"
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={form.data.email}
              onChange={e => form.setData('email', e.target.value)}
              error={form.errors.email}
            />

            <Button type="submit" variant="filled" disabled={form.processing} className="w-full mt-2">
              {form.processing ? 'Sending…' : 'Send reset link'}
            </Button>
          </form>
        )}

        <p className="mt-8 text-center text-xs text-muted font-light">
          <Link
            href="/users/sign_in"
            className="text-body hover:text-heading transition-colors duration-200 underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 rounded"
          >
            Back to sign in
          </Link>
        </p>

      </div>
    </AuthLayout>
  )
}
